module.exports = __webpack_public_path__ + "static/media/LINE1.7aa26586.png";